import { defineMessages } from 'react-intl';

/**
 * Error-boundary messages for the global shortcuts.
 *
 * NOTE: This file currently only exists to seed the translation pipeline. The runtime
 * code still uses the equivalent strings from
 * `@atlassian/navigation-error-boundary` (see `shortcutsMessages` in
 * `get-messages-for-location/messages.ts`). Once translations land, a follow-up
 * changeset will integrate these messages into the UI and remove the legacy copy.
 *
 * See https://hello.jira.atlassian.cloud/browse/NAVX-4866
 */
export const defaultMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.error.header.default',
		defaultMessage: 'We couldn’t load this content',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.description.default',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});
